import React, { useEffect } from 'react';
import compose from 'lodash/fp/compose';
import { withMetrics } from '@catalogo/core-metrics';
import { getImage } from '@catalogo/service-americanas-common/src/helpers/image';
import { closureSetSelectedOption, getOffersQty, getSku, getTextLabel } from '../helpers/sku';
import { WithSkuProps } from '../types';

export const withSku = (Component: React.FC) => (props: WithSkuProps) => {
  const { product, currentSku, parsedQs, history, dispatchMetrics } = props;

  useEffect(() => {
    dispatchMetrics('sku:selected', (currentSku as unknown) as string);
  }, [currentSku.id]);

  const productDiffsInitial = product?.diffs ?? [];
  const productDiffs = productDiffsInitial.map(diff => {
    const typeId = (diff?.type ?? '').toLowerCase();
    const typeLabel = parsedQs[typeId];
    const currentType = productDiffsInitial.find(diffToFind => (diffToFind?.type ?? '').toLowerCase() === typeId);
    const isAvailableOffer = !currentSku || !!getOffersQty(currentSku);

    const currentTypeValues = (diff?.values ?? []).map(currentTypeValue => {
      const skuSelected = getSku(product, currentSku, typeId, currentTypeValue.value);
      const hasImage = (currentTypeValue?.images ?? []).length > 0;
      const image = getImage(currentTypeValue?.images?.[0], 'small');
      const value = currentTypeValue?.value ?? '';
      const key = `${typeId}-${value.replace(' ', '-')}`;
      const isSelected = parsedQs[typeId] === value;
      const hasOffer = !!getOffersQty(skuSelected);
      const handleSelectOption = closureSetSelectedOption(parsedQs, history, typeId, value);

      return {
        hasImage,
        image,
        value,
        key,
        isSelected,
        hasOffer,
        handleSelectOption,
      };
    });

    const textLabel = getTextLabel(typeId, currentTypeValues.length, isAvailableOffer);

    return {
      ...diff,
      ...currentType,
      values: currentTypeValues,
      typeId,
      typeLabel,
      textLabel,
      isAvailableOffer,
    };
  });

  const offersQty = getOffersQty(product) || Object.keys(parsedQs).length;

  const withSkuProps = { ...props, productDiffs, offersQty };

  return <Component {...withSkuProps} />;
};

export default compose(withMetrics, withSku);
